import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import {
  HttpClient,
  HttpResponse,
  HttpParams,
  HttpHeaders,
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
declare var $;

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {
  url = environment.api_url;
  userObj = {
    emailId: '',
  };
  enteredEmail;
  invalidEmail = false;
  @Input() forgotVisible: boolean;
  @Output() closeForgotModalEvent = new EventEmitter<boolean>();

  constructor(private http: HttpClient, private spinner: NgxSpinnerService) {}

  ngOnInit() {}
  send(event, myForm, formValid, modalId) {
    this.spinner.show();

    const body = new HttpParams().append('emailId', this.userObj.emailId);
    this.http
      .get(this.url + '/forgotpassword', { params: body })
      .subscribe((res: any) => {
        this.spinner.hide();
        const result = res;
        if (
          result.data &&
          result.statusCode === '002' &&
          result.data.isExist === false
        ) {
          this.invalidEmail = true;
          myForm.resetForm();
        } else {
          $('#resetModal').modal('show');
          this.enteredEmail = this.userObj.emailId;
          myForm.resetForm();
          const elementObj = document.getElementById(modalId);
          this.closeForgotModalEvent.emit(false);
        }
      });
    // }
  }
  closeForgotModal(form) {
    form.resetForm();
    this.invalidEmail = false;
  }
  closeResetModal() {
    $('.modal-backdrop').css('display', 'none');
    $('body').css('padding-right', '0');
  }
  hideInvalidText() {
    this.invalidEmail = false;
  }
}
